// src/api_scripts/getaudiofiles.js
import { fetchAllPages } from "../paginationUtils";

const getAudioFiles = async (unused, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/audio-file`;

  try {
    // Use the pagination utility to fetch all pages
    const audioFilesArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Audio Files", 1000);

    // Transform audio files to ensure they have a name field for consistency
    const transformedAudioFiles = audioFilesArray.map(audioFile => ({
      ...audioFile,
      name: audioFile.name || audioFile.fileName || audioFile.displayName || audioFile.id
    }));

    console.log("Get Audio Files API Response Data (all pages):", transformedAudioFiles.length, "items");
    return transformedAudioFiles;

  } catch (error) {
    // If it's a 404, the API endpoint doesn't exist in this environment
    if (error.message && (error.message.includes('404') || error.message.includes('Request failed with status code 404'))) {
      console.warn(`Audio Files API endpoint not available (404). This is expected in some environments.`);
      if (setProgress) {
        setProgress((prev) => [
          ...prev,
          { type: 'warning', message: 'Audio Files API not available in this environment (404) - skipping', timestamp: new Date().toLocaleTimeString() }
        ]);
      }
      return []; // Return empty array instead of throwing error
    }

    console.error(`Error fetching Audio Files:`, error);
    throw error; // Re-throw other errors
  }
};

export default getAudioFiles;